import { config } from "JS/Config";
import { BaseService } from "../BaseService";
import { appConstants } from "JS/Helpers/Constants";

export class FBAuthService extends BaseService {
    getFirebaseToken = (dbName: "webcasts" | "courses") =>
        this.ngCall<string>(
            "get",
            appConstants.ngEndpoints.getFirebaseToken(config?.user?.memberId),
            {
                params: { dbName },
            },
        );
}
